<template>
  <div class="supporting-doc">
    <div
      class="supporting-doc__head--title black--text font-weight-medium"
      :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
    >
      <DashboardBreadcrumb :items="breadCrumbItems" />
    </div>
    <div class="supporting-doc__mid-body mt-4">
      <v-card elevation="4" class="px-8 py-6">
        <v-row
          class="loader fill-height py-6"
          align="center"
          justify="center"
          v-if="isSupportingDocFormLoading || retrievingEditExportJob"
        >
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
        <div v-else>
          <div class="supporting-doc-body__header d-sm-flex align-center" :class="{ 'text-center': breakpointXs }">
            <div
              class="supporting-doc__mid-body__header--title fw-600 mb-2"
              :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
            >
              Attach Supporting Documents
              <div class="fs-16">
                (First add the details in
                <span class="primary--text pointer" @click="$router.push({ name: 'dashboard.eSanchit' })"
                  >E-sanchit</span
                >
                )
              </div>
            </div>
            <v-spacer v-if="!breakpointXs"></v-spacer>
            <div class="supporting-doc-body__header__search" :class="{ 'mt-3': breakpointXs, 'mr-4': !breakpointXs }">
              <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
            </div>
            <div class="supporting-doc-body__header--button" :class="{ 'mt-3': breakpointXs }">
              <v-btn width="180" color="button-primary" large class="white--text" @click="attachNewSupportingDoc">
                <v-icon left>fas fa-plus</v-icon>
                <span class="font-weight-bold fs-15">Attach New</span>
              </v-btn>
            </div>
          </div>
          <div class="supporting-doc__mid-body__body fs-25 fw-600">
            <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
              <v-row>
                <v-col cols="12" :xs="12" :sm="12" :md="12" :lg="12">
                  <v-data-table :headers="tableHeaders" :items="supportingDocs" :search="search" :items-per-page="10">
                    <template v-slot:item.documentLevel="{ item }">
                      <span>{{ getDocumentLevel(item) }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-row>
                        <v-col cols="12" :xs="6" :sm="6" :md="6" :lg="6" class="text-left pl-1">
                          <v-btn
                            color="lightPrimary"
                            class=" error font-weight-bold"
                            dense
                            @click="deleteActionHandler(item)"
                            >Delete</v-btn
                          >
                        </v-col>
                      </v-row>
                    </template></v-data-table
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
                    <v-btn
                      width="140"
                      color="info"
                      large
                      class="white--text"
                      :loading="isSupportingDocFormLoading || savingExportJob"
                      @click="$router.push({ name: 'dashboard.export.shipment' })"
                    >
                      <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
                      <span class="font-weight-bold fs-15">Previous</span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
                    <v-btn
                      width="140"
                      color="indigo"
                      large
                      class="white--text mr-4"
                      :loading="isSupportingDocFormLoading || isCheckListButtonLoading || savingExportJob"
                      @click="generateChecklist(exportJobId)"
                    >
                      <span class="font-weight-bold fs-15">Checklist</span>
                      <v-icon class="font-weight-bold fs-15 ml-2">fa fa-file</v-icon>
                    </v-btn>
                    <v-btn
                      width="140"
                      color="button-primary"
                      large
                      class="white--text mr-4"
                      :loading="isSupportingDocFormLoading || savingExportJob"
                      @click="passes(saveSupportingDoc)"
                    >
                      <span class="font-weight-bold fs-15">Save</span>
                    </v-btn>
                    <v-btn
                      color="info"
                      large
                      class="white--text"
                      :loading="isSupportingDocFormLoading || savingExportJob"
                      @click="$router.push({ name: 'dashboard.export' })"
                    >
                      <span class="font-weight-bold fs-15">Move to Export</span>
                      <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
                    </v-btn>
                    <div class="ml-2 mr-2 my-1"></div>
                  </div>
                </v-col>
              </v-row>
            </ValidationObserver>
          </div>
        </div>
      </v-card>
    </div>
    <AddSupportingDocModal
      v-if="showAddSupportinDoc"
      @close-supporting-doc-modal="showAddSupportinDoc = !showAddSupportinDoc"
    />
  </div>
</template>
<script>
import DashboardBreadcrumb from "@/modules/DashboardModule/components/DashboardBreadcrumb";
import AddSupportingDocModal from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/AddSupportingDocModal";
import { ValidationObserver } from "vee-validate";
// import TextField from "@/components/TextField";
// import SelectField from "@/components/SelectField";
// import AutoComplete from "@/components/AutoComplete";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
// import { SNACKBAR } from "@/store/actionTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "SupportingDoc",
  components: {
    DashboardBreadcrumb,
    ValidationObserver,
    AddSupportingDocModal
    // TextField,
    // SelectField,
    // AutoComplete
  },
  data() {
    return {
      isSupportingDocFormLoading: false,
      isCheckListButtonLoading: false,
      search: null,
      showAddSupportinDoc: false
    };
  },
  props: {
    srNo: {
      type: Number,
      default: 1
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    attachNewSupportingDoc() {
      this.showAddSupportinDoc = true;
      return;
    },

    deleteActionHandler(item) {
      this.$store.commit(MT.DELETE_SUPPORTING_DOC_FROM_EXPORT_JOB, { srNo: item.srNo });
      this.$store.commit(MT.REASSIGN_SRNO_TO_SUPPORTING_DOCS_IN_EXPORT_JOB, { srNo: item.srNo });
      return;
    },
    saveSupportingDoc() {
      this.saveExportJob();
    },
    getDocumentLevel(supportingDoc) {
      if (supportingDoc.invoiceSrNo !== undefined && parseInt(supportingDoc.invoiceSrNo) !== 0) {
        if (supportingDoc.itemSrNo !== undefined && parseInt(supportingDoc.itemSrNo) !== 0) {
          return "Item level";
        }
        return "Invoice level";
      }
      return "Job level";
    }
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  computed: {
    tableHeaders() {
      return [
        { text: "Sr No.", value: "srNo", align: "center" },
        { text: "Image Ref. No (IRN)", value: "imgReferenceNo", align: "center" },
        { text: "Document Type", value: "documentTypeCode", align: "center" },
        { text: "ICEGATE Filename", value: "icegateFileName", align: "center" },
        { text: "Doc Ref. No", value: "documentReferenceNo", align: "center" },
        { text: "Document Level", value: "documentLevelTitle", align: "center" },
        { text: "Action", value: "action", align: "center" }
      ];
    },
    supportingDocs() {
      //   return [];
      return this.$store.getters.exportJob.supportingDocs;
    },
    exportJobId() {
      const exportJobId = {
        id: this.$store.getters.exportJobId
      };
      return exportJobId;
    },
    breadCrumbItems() {
      return [
        {
          title: "Dashboard",
          route: "dashboard.home",
          children: [
            {
              title: "Export",
              route: "dashboard.export",
              children: [
                {
                  title: "Supporting Doc",
                  route: "dashboard.export.supporting-doc"
                }
              ]
            }
          ]
        }
      ];
    }
  }
};
</script>
<style lang="scss">
.supporting-doc {
  &__mid-body {
    &__table {
      .v-data-table {
        background: transparent !important;
      }
    }
  }
}
</style>
